module.exports = __webpack_public_path__ + "img/stergios-tsakalakis.59de2561.jpg";